import { useNavigate } from "react-router-dom";
import HourglassImage from "./assets/hourglass.svg?react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import {
  ShieldCheckIcon,
  XMarkIcon,
  CreditCardIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/solid";
import { InfoPage } from "@shared/praxis-config";
import { routes } from "../../routing/routes";
import { FormWrapper } from "../../components/form-wrapper";
import { Info } from "../../components/info";
import { useTranslation } from "react-i18next";
import { usePraxis } from "../../praxis-config/praxis-context";
import { useLocalizedText } from "../../praxis-config/use-localized-text";

const InfoPageItem: React.FC<{ page: InfoPage }> = ({ page }) => (
  <Info Icon={InformationCircleIcon}>{useLocalizedText(page.title)}</Info>
);

const SubmitButtonContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      {t("pages.almost_done.submit")} <ArrowRightIcon width={15} />
    </>
  );
};

export const AlmostDonePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { config } = usePraxis();

  const onSubmit = () => {
    navigate(routes.questionnaire.cancelAppointment);
  };

  return (
    <FormWrapper onSubmit={onSubmit} SubmitButtonContent={SubmitButtonContent}>
      <div className="flex flex-col items-center gap-5 w-fit mx-auto">
        <span className="text-2xl font-light text-text-primary text-center">
          {t("pages.almost_done.title")}
        </span>
        <HourglassImage className="max-w-full w-[150px] text-primary my-5" />
        <div className="flex flex-col gap-6 mb-3 self-start">
          <span className="text-md text-gray-700">
            {t("pages.almost_done.description")}
          </span>
          <div className="flex flex-col gap-4 w-full">
            <Info Icon={XMarkIcon}>
              {t("pages.almost_done.cancel_appointment")}
            </Info>
            <Info Icon={CreditCardIcon}>
              {t("pages.almost_done.extra_costs")}
            </Info>
            {config.infoPages.map((page) => (
              <InfoPageItem key={page.id} page={page} />
            ))}
            <Info Icon={ShieldCheckIcon}>{t("pages.almost_done.privacy")}</Info>
          </div>
        </div>
      </div>
    </FormWrapper>
  );
};
